import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { TCompleteVariables, TInterviewCompletion } from './completeAndCancel';

import { notify, notifyMeta } from '@/lib/notify';
import { INTERVIEW_CALL_COPY } from '@/constants/interviewCall';
import { APPLICANT_KEYS, COUNTER_KEYS, INTERVIEW_KEYS } from '@/constants/queryKeys';

import { completeAndCancel } from './completeAndCancel';

const useCompleteInterview = () => {
  const queryClient = useQueryClient();

  return useMutation<TInterviewCompletion, Error, TCompleteVariables>({
    meta: notifyMeta('interviewComplete'),
    mutationKey: ['interviews', 'complete'],
    mutationFn: completeAndCancel,
    onSuccess: async (outcome) => {
      if (outcome.calendly === 'failed') {
        notify.error(INTERVIEW_CALL_COPY.calendlyNotCanceled);
      }

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: APPLICANT_KEYS.root }),
        queryClient.invalidateQueries({ queryKey: INTERVIEW_KEYS.root }),
        queryClient.invalidateQueries({ queryKey: COUNTER_KEYS.root }),
      ]);
    },
  });
};

export {
  useCompleteInterview,
};
